/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrderDto } from './OrderDto';
import {
    OrderDtoFromJSON,
    OrderDtoFromJSONTyped,
    OrderDtoToJSON,
    OrderDtoToJSONTyped,
} from './OrderDto';

/**
 * 
 * @export
 * @interface OrderDtoPagedResponseDto
 */
export interface OrderDtoPagedResponseDto {
    /**
     * 
     * @type {Array<OrderDto>}
     * @memberof OrderDtoPagedResponseDto
     */
    items?: Array<OrderDto> | null;
    /**
     * 
     * @type {number}
     * @memberof OrderDtoPagedResponseDto
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderDtoPagedResponseDto
     */
    pageIndex?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderDtoPagedResponseDto
     */
    pageSize?: number;
}

/**
 * Check if a given object implements the OrderDtoPagedResponseDto interface.
 */
export function instanceOfOrderDtoPagedResponseDto(value: object): value is OrderDtoPagedResponseDto {
    return true;
}

export function OrderDtoPagedResponseDtoFromJSON(json: any): OrderDtoPagedResponseDto {
    return OrderDtoPagedResponseDtoFromJSONTyped(json, false);
}

export function OrderDtoPagedResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderDtoPagedResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(OrderDtoFromJSON)),
        'totalCount': json['totalCount'] == null ? undefined : json['totalCount'],
        'pageIndex': json['pageIndex'] == null ? undefined : json['pageIndex'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
    };
}

export function OrderDtoPagedResponseDtoToJSON(json: any): OrderDtoPagedResponseDto {
    return OrderDtoPagedResponseDtoToJSONTyped(json, false);
}

export function OrderDtoPagedResponseDtoToJSONTyped(value?: OrderDtoPagedResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(OrderDtoToJSON)),
        'totalCount': value['totalCount'],
        'pageIndex': value['pageIndex'],
        'pageSize': value['pageSize'],
    };
}

